module.exports = __webpack_public_path__ + "static/a-tale-of-two-olympic-victories-bfe6ca67df3664c07c5af75c0279b0c4.jpg";